module.exports = __webpack_public_path__ + "img/pierre.918899bc.jpg";